module.exports = __webpack_public_path__ + "static/media/32.7b7c6360.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/poinkos/32.jpg
// module id = 565
// module chunks = 0